import { useCallback } from "react";
import * as Actions from "../actions";
import { useDomainUseCase } from "./useDomainUseCase";
import * as LiveSessionStates from "../constants/liveSessionStates";

export const useLiveSessionDomainActions = () => {
  const { execute } = useDomainUseCase();

  const getLiveSession = useCallback((liveSessionId) => {
    execute({
      useCase: "GetLiveSessionUseCase",
      params: { id: liveSessionId },
      getLoadingAction: Actions.getLiveSession.bind(Actions, liveSessionId),
      getErrorAction: Actions.getLiveSessionError,
      getSuccessAction: Actions.getLiveSessionSuccess,
    });
  }, []);

  const updateLiveSession = useCallback(({ id, title, description, language, scheduledAt }) => {
    execute({
      useCase: "UpdateLiveSessionUseCase",
      params: { id, title, description, language, scheduledAt },
      getLoadingAction: Actions.updateLiveSession,
      getErrorAction: Actions.updateLiveSessionError,
      getSuccessAction: Actions.updateLiveSessionSuccess,
    });
  }, []);

  const getLiveSessionsList = useCallback(
    ({ sort = [], pageNumber = 1, pageSize = 1, courseId, state = [], hasRecording = "" }) => {
      const filter = { courseId, state: state.join(","), hasRecording };
      const pagination = { number: pageNumber, size: pageSize };
      execute({
        useCase: "GetListLiveSessionUseCase",
        params: { sort, pagination, filter },
        getLoadingAction: Actions.getLiveSessionsList.bind(Actions, { pageSize }),
        getErrorAction: Actions.getLiveSessionsListError,
        getSuccessAction: Actions.getLiveSessionsListSuccess,
      });
    },
    []
  );

  const getActiveLiveSessionByCourse = useCallback(({ courseId }) => {
    const state = [
      LiveSessionStates.SCHEDULED,
      LiveSessionStates.READY,
      LiveSessionStates.STREAMING,
    ];
    const filter = { courseId, state: state.join(",") };
    const pagination = { number: 1, size: 1 };
    execute({
      useCase: "GetListLiveSessionUseCase",
      params: { sort: [], pagination, filter },
      getLoadingAction: Actions.getActiveLiveSessionByCourse,
      getErrorAction: Actions.getActiveLiveSessionByCourseError,
      getSuccessAction: Actions.getActiveLiveSessionByCourseSuccess,
    });
  }, []);

  return {
    getLiveSession,
    updateLiveSession,
    getLiveSessionsList,
    getActiveLiveSessionByCourse,
  };
};
